import cx from "classnames";
import _ from "lodash";
import React from "react";
import { findDOMNode } from "react-dom";
import styles from "./PoiBar.scss";

const MIN_TAG_WIDTH = 130;
const SCROLL_BUTTON_WIDTH = 35;

// the current scroll system here does not work with devices/touch input
// that allows horizontal scrolling. This is an engineering tradeoff, where
// supporting native scrolling in addition to button-based scrolling would
// result in ~3x more code
export class PoiBar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tagsVisible: 4, // safe default for most screen widths
      scrollOffset: 0,
    };
    this._throttledOnResize = _.throttle(this.onResize, 100);
  }

  componentDidMount() {
    this.computeLayout();
    window.addEventListener("resize", this._throttledOnResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._throttledOnResize);
  }

  onResize = () => {
    this.computeLayout();
  };

  computeLayout() {
    const { poiTags } = this.props;
    const { scrollOffset } = this.state;
    const node = findDOMNode(this);
    const availableWidth = node.clientWidth;
    const tagCountNoScrollButtons = Math.floor(availableWidth / MIN_TAG_WIDTH);
    if (tagCountNoScrollButtons >= poiTags.length) {
      this.setState({ tagsVisible: tagCountNoScrollButtons, scrollOffset: 0 });
      return;
    }
    const tagCountWithScrollButtons = Math.floor((availableWidth - 2 * SCROLL_BUTTON_WIDTH) / MIN_TAG_WIDTH);
    // if we've revealed more tags, downgrade scrollOffset
    const newMaxOffset = poiTags.length - tagCountWithScrollButtons;
    const newOffset = Math.min(newMaxOffset, scrollOffset);
    this.setState({
      tagsVisible: tagCountWithScrollButtons,
      scrollOffset: newOffset,
    });
  }

  scrollForward = () => {
    const { tagsVisible, scrollOffset } = this.state;
    const { poiTags } = this.props;
    if (poiTags.length <= tagsVisible + scrollOffset) {
      return;
    }
    this.setState({ scrollOffset: scrollOffset + 1 });
  };

  scrollBackward = () => {
    const { scrollOffset } = this.state;
    if (scrollOffset === 0) {
      return;
    }
    this.setState({ scrollOffset: scrollOffset - 1 });
  };

  render() {
    const { poiTags, selectedTags, toggleTag } = this.props;
    const { tagsVisible, scrollOffset } = this.state;
    const hasScroll = tagsVisible < poiTags.length;
    return (
      <div className={styles.PoiBar}>
        {hasScroll && (
          <a
            className={cx(styles.scrollButton, styles.left, scrollOffset === 0 && styles.disabled)}
            onClick={this.scrollBackward}
          >
            scroll left
          </a>
        )}
        {poiTags.slice(scrollOffset, scrollOffset + tagsVisible).map((t) => (
          <a
            key={t.tag}
            className={cx(styles.tag, selectedTags.has(t.tag) && styles.active)}
            onClick={() => toggleTag(t.tag)}
          >
            {t.tag}
          </a>
        ))}
        {hasScroll && (
          <a
            className={cx(
              styles.scrollButton,
              styles.right,
              scrollOffset >= poiTags.length - tagsVisible && styles.disabled
            )}
            onClick={this.scrollForward}
          >
            scroll right
          </a>
        )}
      </div>
    );
  }
}
